// import React, { useState } from "react";
// import ChatSidebar from "./ChatSidebar";
// import ChatWindow from "./ChatWindow";
// import "./chat.scss";

// const Help = () => {
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [conversations, setConversations] = useState({});

//   const users = [
//     { id: 1, name: "Alice" },
//     { id: 2, name: "Bob" },
//     { id: 3, name: "Charlie" },
//   ];

//   const handleUserSelect = (user) => {
//     setSelectedUser(user);
//   };

//   const handleAddMessage = (message) => {
//     if (selectedUser) {
//       setConversations((prevConversations) => {
//         const userId = selectedUser.id;
//         const newMessages = [
//           ...(prevConversations[userId] || []),
//           { text: message, sender: "You" },
//         ];
//         // Static response
//         setTimeout(() => {
//           setConversations((prevConversations) => ({
//             ...prevConversations,
//             [userId]: [
//               ...newMessages,
//               {
//                 text: "This is a static response from the bot.",
//                 sender: "Bot",
//               },
//             ],
//           }));
//         }, 1000); // Adjust the delay as needed
//         return { ...prevConversations, [userId]: newMessages };
//       });
//     }
//   };
//   return (
//     <div className="mt-3">
//       <div className="shadow-lg" style={{ backgroundColor: "white" }}>
//         <div className="chatIn flex">
//           <ChatSidebar
//             users={users}
//             onUserSelect={handleUserSelect}
//             selectedUser={selectedUser}
//           />
//           <ChatWindow
//             user={selectedUser}
//             messages={conversations[selectedUser?.id] || []}
//             onAddMessage={handleAddMessage}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Help;

import React, { useCallback, useEffect, useMemo, useState } from "react";
import ChatWindow from "./ChatWindow";
import UserTable from "./UserTable"; // Import the new UserTable component
import "./chat.scss";
import { useWebSocketContext } from "context/WebSocketContext";
import {
  _getEscalationRequests,
  _updateEscalationRequest,
  _getEscalationHistory,
} from "Services/api";

const isChatEscalation = (request) => request.flowType === "chat_escalation";
const isUnreadOpenRequest = (request) => !request.is_read && !request.isResolved;

const Help = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [showChat, setShowChat] = useState(false); // New state to control UI
  const [users, setUsers] = useState([]);
  const [chatId, setChatId] = useState(null);
  const [clientId, setClientID] = useState();
  const [activeTab, setActiveTab] = useState("escalation");
  const [callbackRequests, setCallbackRequests] = useState([]);
  const [unreadCount, setUnreadCount] = useState({ escalation: 0, callback: 0 });
  const { socketMessage } = useWebSocketContext();

  const accessToken = sessionStorage.getItem("VendorToken");

  const fetchEscalationRequests = useCallback(async () => {
    const botDetails = JSON.parse(sessionStorage.getItem("botData"));
    if (!botDetails) return;

    try {
      const response = await _getEscalationRequests({
        bot_id: botDetails.bot_id || botDetails.unique_id,
        page: 1,
        limit: 10,
        room_no: "",
        accessToken,
      });
      const fetchedRequests = response.data.escalation_requests || [];
      const mappedRequests = fetchedRequests.map((request) => {
        const flowType =
          request.flow_type ||
          request.flow ||
          (request.escalation_chat_id ? "chat_escalation" : "request_callback");

        return {
          id: request.escalation_request_id,
          name: request.full_name || "Unknown guest",
          email: request.email || "No email provided",
          phone: request.phone || request.phone_number || "No phone provided",
          issue: request.issue || "No issue provided",
          roomNo: request.room_no,
          isResolved: request.is_resolved,
          flowType,
          comment: request.comment || "No comment",
          escalation_request_id: request.escalation_request_id,
          escalation_chat_id: request.escalation_chat_id,
          is_read: request.is_read,
          user_id: request.user_id || request.client_id,
        };
      });

      const escalationRequests = mappedRequests.filter(isChatEscalation);
      const callbackRequestList = mappedRequests.filter((request) => !isChatEscalation(request));

      setUsers(escalationRequests);
      setCallbackRequests(callbackRequestList);
      setUnreadCount({
        escalation: escalationRequests.filter(isUnreadOpenRequest).length,
        callback: callbackRequestList.filter(isUnreadOpenRequest).length,
      });
    } catch (error) {
      console.error("Failed to fetch escalation requests", error);
    }
  }, [accessToken]);

  useEffect(() => {
    fetchEscalationRequests();
    const intervalId = window.setInterval(fetchEscalationRequests, 15000);
    return () => window.clearInterval(intervalId);
  }, [fetchEscalationRequests]);

  useEffect(() => {
    if (!socketMessage) return;
    if (
      socketMessage.event_type === "USER_MESSAGE" ||
      socketMessage.event_type === "AGENT_NEW_NOTIFICATION" ||
      socketMessage.event_type === "USER_NEW_NOTIFICATION"
    ) {
      fetchEscalationRequests();
    }
  }, [fetchEscalationRequests, socketMessage]);

  const updateEscalationRequest = async (escalationId) => {
    try {
      const payload = { is_read: true };

      const response = await _updateEscalationRequest({
        escalationId,
        payload,
        accessToken,
      });
    } catch (error) {
      console.error("Failed to update escalation request", error);
    }
  };
  const fetchEscalationHistory = async (escalationId) => {
    try {
      const response = await _getEscalationHistory({
        accessToken: sessionStorage.getItem("VendorToken"),
        escalationId: escalationId,
      });
      if (response.status) {
        const chatHistory = response.data.chat_history?.chat || response.data.history || [];
        setChatId(
          response.data.escalation_chat_id || response.data.chat_history?.escalation_chat_id
        );
        const historyMessages = chatHistory.map((item) => {
          return {
            id: item.id,
            text: item.message,
            sender: item.user_type === "chatbot_user" ? "User" : "You",
            timestamp: item.timestamp,
          };
        });
        setConversations((prevConversations) => [...historyMessages]);
      }
    } catch (error) {
      console.error("Failed to fetch escalation history", error);
    }
  };

  const handleUserSelect = async (user) => {
    setSelectedUser(user);
    setShowChat(true);
    setClientID(user.user_id);
    setChatId(user.escalation_chat_id);
    // Fetch escalation history
    await fetchEscalationHistory(user.escalation_request_id);
    await updateEscalationRequest(user.escalation_request_id);
    setUsers((prevUsers) =>
      prevUsers.map((item) =>
        item.escalation_request_id === user.escalation_request_id
          ? { ...item, is_read: true }
          : item
      )
    );
    setUnreadCount((prev) => ({
      ...prev,
      escalation: Math.max(prev.escalation - (user.is_read ? 0 : 1), 0),
    }));
  };
  const handleAddMessage = (messageObj) => {
    setConversations((prevConversations) => [
      ...prevConversations,
      messageObj, // Directly add the message object
    ]);
  };

  const findRequestById = (requestId) =>
    [...users, ...callbackRequests].find((request) => request.escalation_request_id === requestId);

  const handleResolveEscalation = async (requestOrId = selectedUser) => {
    const requestId =
      typeof requestOrId === "string"
        ? requestOrId
        : requestOrId?.escalation_request_id || selectedUser?.escalation_request_id;
    const requestToResolve =
      typeof requestOrId === "object" && requestOrId !== null
        ? requestOrId
        : findRequestById(requestId);

    if (!requestId) return;

    try {
      await _updateEscalationRequest({
        escalationId: requestId,
        payload: { is_resolved: true },
        accessToken,
      });

      const markResolved = (request) =>
        request.escalation_request_id === requestId
          ? { ...request, isResolved: true, is_read: true }
          : request;

      setUsers((prevUsers) => prevUsers.map(markResolved));
      setCallbackRequests((prevRequests) => prevRequests.map(markResolved));
      setUnreadCount((prev) => {
        if (!requestToResolve || requestToResolve.is_read || requestToResolve.isResolved) {
          return prev;
        }

        const unreadBucket = isChatEscalation(requestToResolve) ? "escalation" : "callback";
        return {
          ...prev,
          [unreadBucket]: Math.max(prev[unreadBucket] - 1, 0),
        };
      });

      const resolvedOpenChat =
        selectedUser?.escalation_request_id && selectedUser.escalation_request_id === requestId;

      setSelectedUser((currentUser) =>
        currentUser?.escalation_request_id === requestId
          ? { ...currentUser, isResolved: true, is_read: true }
          : currentUser
      );

      if (resolvedOpenChat) {
        setShowChat(false);
        setSelectedUser(null);
        setConversations([]);
        setChatId(null);
      }
    } catch (error) {
      console.error("Failed to resolve escalation request", error);
    }
  };

  const activeRequests = activeTab === "escalation" ? users : callbackRequests;
  const emptyMessage =
    activeTab === "escalation" ? "No escalation requests found." : "No callback requests found.";

  const totalUnread = useMemo(
    () => unreadCount.escalation + unreadCount.callback,
    [unreadCount.callback, unreadCount.escalation]
  );

  return (
    <div className="mt-3">
      <div className="shadow-lg" style={{ backgroundColor: "white" }}>
        {/* Header with Title and Unread Badge */}
        <div className="border-b border-gray-200 px-6 py-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-800">Support & Callbacks</h2>
            {totalUnread > 0 && (
              <span className="inline-flex items-center justify-center rounded-full bg-blue-500 px-3 py-1 text-xs font-semibold text-white">
                {totalUnread} Unread
              </span>
            )}
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200">
          <div className="flex px-6">
            <button
              onClick={() => {
                setActiveTab("escalation");
                if (showChat) {
                  setShowChat(false);
                  setSelectedUser(null);
                  setConversations([]);
                  setChatId(null);
                }
              }}
              className={`relative py-3 px-1 text-sm font-medium transition-colors ${
                activeTab === "escalation" ? "text-blue-600" : "text-gray-600 hover:text-gray-800"
              }`}
            >
              <div className="flex items-center gap-2">
                Chat Escalation
                {unreadCount.escalation > 0 && (
                  <span className="inline-flex items-center justify-center rounded-full bg-blue-500 px-2 py-0.5 text-xs font-semibold text-white">
                    {unreadCount.escalation}
                  </span>
                )}
              </div>
              {activeTab === "escalation" && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></div>
              )}
            </button>

            <button
              onClick={() => {
                setActiveTab("callback");
                if (showChat) {
                  setShowChat(false);
                  setSelectedUser(null);
                  setConversations([]);
                  setChatId(null);
                }
              }}
              className={`relative ml-6 py-3 px-1 text-sm font-medium transition-colors ${
                activeTab === "callback" ? "text-blue-600" : "text-gray-600 hover:text-gray-800"
              }`}
            >
              <div className="flex items-center gap-2">
                Request Callback
                {unreadCount.callback > 0 && (
                  <span className="inline-flex items-center justify-center rounded-full bg-blue-500 px-2 py-0.5 text-xs font-semibold text-white">
                    {unreadCount.callback}
                  </span>
                )}
              </div>
              {activeTab === "callback" && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></div>
              )}
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="chatIn flex">
          {!showChat ? (
            activeRequests.length > 0 ? (
              <UserTable
                users={activeRequests}
                onUserSelect={handleUserSelect}
                onResolve={handleResolveEscalation}
              />
            ) : (
              <div className="flex h-64 w-full items-center justify-center">
                <p className="text-lg text-gray-500">{emptyMessage}</p>
              </div>
            )
          ) : (
            <div className="flex w-full">
              <ChatWindow
                chatId={chatId}
                user={selectedUser}
                messages={conversations}
                onAddMessage={handleAddMessage}
                clientId={clientId}
                onResolve={handleResolveEscalation}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Help;
